package com.eladfinish.bible.contest.domain.catalog

fun String.toBookIndex(): Int =
    BibleCatalog.books.indexOfFirst { it.hebrew == this }
        .takeIf { it >= 0 }
        ?: error("Unknown book: $this")
